import { PROP_TYPE_HINT, type RegistryEntry } from "../types/customElements";
import { CUSTOM_ELEMENT_NAME, type CustomElementName } from "./customElementNames";

export { CUSTOM_ELEMENT_NAME, type CustomElementName } from "./customElementNames";
export {
  SCRIPT_PROP_SELECTOR,
  EASY_CUSTOM_ELEMENTS_PREFIX,
  SCRIPT_PROPS_KEY,
  customElementTag,
} from "./customElementNames";

export const CUSTOM_ELEMENTS_REGISTRY: Record<CustomElementName, RegistryEntry> = {
  [CUSTOM_ELEMENT_NAME.ActionMenu]: {
    loadComponent: () => import("@/src/shared_modules/action_menu/ActionMenu.vue"),
    propTypes: {
      offset: PROP_TYPE_HINT.Number,
      inheritActivatorWidth: PROP_TYPE_HINT.Boolean,
      disabled: PROP_TYPE_HINT.Boolean,
    },
    slots: ["items"],
    emits: ["item:select"],
  },
  [CUSTOM_ELEMENT_NAME.Autocomplete]: {
    loadComponent: () => import("@/src/shared_modules/autocomplete/Autocomplete.vue"),
    propTypes: {
      inlineEdit: PROP_TYPE_HINT.Boolean,
      hiddenLabel: PROP_TYPE_HINT.Boolean,
      disabled: PROP_TYPE_HINT.Boolean,
      multiple: PROP_TYPE_HINT.Boolean,
      required: PROP_TYPE_HINT.Boolean,
      clearable: PROP_TYPE_HINT.Boolean,
    },
    modelValueType: PROP_TYPE_HINT.String,
  },
  [CUSTOM_ELEMENT_NAME.TranslatableTextField]: {
    loadComponent: () => import("@/src/shared_modules/translatable_text_field/components/TranslatableTextField.vue"),
    propTypes: {
      inlineEdit: PROP_TYPE_HINT.Boolean,
      hiddenLabel: PROP_TYPE_HINT.Boolean,
      disabled: PROP_TYPE_HINT.Boolean,
      readonly: PROP_TYPE_HINT.Boolean,
      required: PROP_TYPE_HINT.Boolean,
      clearable: PROP_TYPE_HINT.Boolean,
    },
    modelValueType: PROP_TYPE_HINT.String,
  },
  [CUSTOM_ELEMENT_NAME.FeatureHint]: {
    loadComponent: () => import("@/src/shared_modules/feature_hints/components/FeatureHint.vue"),
    propTypes: {
      priority: PROP_TYPE_HINT.Number,
      spotlight: PROP_TYPE_HINT.Boolean,
    },
  },
};
